import { getFontFamilyStylePure } from '@goldcast/player-config/src/utils/fontUtils';
import { brandKit, clipsBrandKit, platformBrandKitStore } from '@/stores/brandKit';
import { currentClip } from '@/stores/clip';
import { currentUser } from '@/stores/user';

// TODO: @AshwinBhatkal to test cases with just extracting from font location
export const getFontFamilyStyle = (clipId: string, fontLocation?: string) => {
  const clip = currentClip.getSnapshot()[clipId];
  const clipBrandKitStore = clipsBrandKit.getSnapshot()[clipId];
  const brandKitStore = brandKit.getSnapshot();
  const platformBrandKit = platformBrandKitStore.getSnapshot();
  const organization = currentUser.getSnapshot()?.organization;
  return getFontFamilyStylePure({
    clip,
    organization,
    clipBrandKitStore,
    brandKitStore,
    platformBrandKit,
    fontLocation
  });
};
